module.exports = __webpack_public_path__ + "img/exchange-selected.db08d7e8.png";